import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
 
 
  box-sizing: border-box;
  width:100%;
  background-color:#1F1F1F;
  padding:5% 0% 5% 0%;

  @media (max-width: 500px) {
    padding:0% 0% 10% 0%;
  }

`;

const SectionWrapper = styled.section`
  box-sizing: border-box;
  width: 60%;
  margin: 0 auto;
  background-color: #1F1F1F;
  display: flex;
  flex-direction: column; /* 上下排列 */
  justify-content: space-between;

  @media (max-width: 500px) {
    width: 90%;
    padding: 0%;
  }
`;

const UpperSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 500px) {
    flex-direction: column; /* 寬度大於 500 時，改回左右排列 */
    justify-content: space-between;
  }
`;


const Title = styled.h2`
  text-align: left;
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 70px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  padding: 0% 0% 2% 0%;

  span {
    color: #FFF56A;
  }

  p {
    font-weight: 400;
    font-size: 18px;
    line-height: 32px;
    color: #AFAFAF;
  }

  @media (max-width: 500px) {
    width: 100%;
    font-weight: 700;
    font-size: 32px;
    line-height: 46px;
    padding: 5% 0% 0% 0%;
    text-align: center;
    margin-bottom:0px;

    p{
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }

  }
`;

const Button = styled.a`
  text-decoration: none;
  background-color:transparent;
  color:#FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;

  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;

  
  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    margin-top:0px;
    padding: 6px 20px;
    margin: 0 auto;

  }

  &:hover {
    background-color:#FFFFFF;
    color:#1f1f1f;
  }
`;

const LowerSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;

  @media (max-width: 500px) {
    flex-direction: column;
    padding:5% 0% 0% 0%;
  }
`;

const LeftImage = styled.img`
  width: 60%; /* 調整左邊圖片寬度 */
  height: auto;
  border-radius: 30px;

  @media (max-width: 500px) {
    width: 100%;
    padding:0% 0% 0% 0%;

  }
`;

const RightImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 500px) {
    width: 100%; /* 在小屏幕時，右邊佔滿寬度 */
  }
`;

const RightImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 30px;

  @media (max-width: 500px) {
    width: 100%; 
    height: auto;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 500px) {
    flex-direction: row;
  }

`;




const DAOSection5 = () => (
  <Section>
    <SectionWrapper>
      <UpperSection>
        <Title>DAO建構及運作驗證<span>.</span><p>串接靈魂綁定代幣與現有 DAO 治理工具以初步驗證分散式身份與分散式自治組織運作之可能</p></Title>
        <ButtonGroup>
        <Button href="https://frontierdao-plurality.on.fleek.co/#/molochv3/0x5/0x0f237a040e0e518eba846cf4c6ada80a02b77102" target="_blank" style={{ textDecoration: 'none' }}>了解DAO</Button>
        <Button href="https://drive.google.com/file/d/1bRGBkevKEwcrUbLELyDY58i2eusXul5Y/view?usp=sharing" target="_blank" style={{ textDecoration: 'none' }}>閱讀更多</Button>
        </ButtonGroup>
      </UpperSection>
      <LowerSection>
        <LeftImage src="/images/DAOSec5_1.png" alt="Left Image" />
        <RightImageContainer>
          {/* 右上方圖片 */}
          <RightImage src="/images/DAOSec5_2.png" alt="Top Right Image" />
          {/* 右下方圖片 */}
          <RightImage src="/images/DAOSec5_3.png" alt="Bottom Right Image" />
        </RightImageContainer>
      </LowerSection>
    </SectionWrapper>
  </Section>
);

export default DAOSection5;
